import type { Candidate } from 'model/Candidate/Candidate';

import { CandidateHistoryAction } from 'services/candidates/types';
import { useCandidateHistoryQuery } from 'shared/legacy/hooks/useCandidateHistoryQuery';
import { CandidateHistory } from 'shared/legacy/hooks/useCandidateHistoryQuery.types';
import { useIndeedConfig } from './useIndeedConfig';

type IndeedMetadata = {
  conversation_id: any;
  job_seeker_key: any;
  license_email_address: any;
};

const isValidIndeedMetadata = (
  metadata: CandidateHistory['metadata'],
  email: string | null,
): metadata is IndeedMetadata =>
  !!metadata &&
  metadata.conversation_id !== null &&
  metadata.job_seeker_key !== null &&
  metadata.license_email_address === email;

export const useIndeedReply = (candidate: Candidate | null) => {
  const { email } = useIndeedConfig();
  const { data: history } = useCandidateHistoryQuery(candidate, { enabled: false });

  if (!candidate) {
    return { isReply: false, metadata: null };
  }

  const reply = history?.find(
    (h) => h.action === CandidateHistoryAction.IndeedReceived && isValidIndeedMetadata(h.metadata, email),
  );

  return { isReply: !!reply, metadata: (reply?.metadata as IndeedMetadata | undefined) ?? null };
};
